import { Modal, Button } from 'react-bootstrap';
import './ModalLink.css'; // Importe seu arquivo CSS aqui

interface ModalLinkProps {
  show: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  actions: {
    label: string;
    onClick: () => void;
  }[];
}

function ModalLink(props: ModalLinkProps) {
  return (
    <Modal 
      show={props.show} 
      onHide={props.onClose}
      centered // Centraliza o modal na tela (opcional, mas recomendado)
      backdropClassName="custom-backdrop-blur" // Classe customizada para o fundo
      style={{ zIndex: 10500 }} // Força um z-index muito alto para ficar "por cima de tudo"
    >
      <Modal.Header>
        <Modal.Title>{props.title}</Modal.Title>
        <button type='button' className='btn-close' aria-label='Close' onClick={props.onClose} />
      </Modal.Header>
      <Modal.Body>
        {props.children}
      </Modal.Body>
      <Modal.Footer>
        {props.actions.map((action, index) => (
          <Button key={index} variant="primary" onClick={action.onClick}>
            {action.label}
          </Button>
        ))}
      </Modal.Footer>
    </Modal>
  );
}

export default ModalLink;